"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCategoriesByIdsEndpointRequest = void 0;
const categoryEndpointsParameter_1 = require("./categoryEndpointsParameter");
function createCategoriesByIdsEndpointRequest(parameters) {
    var _a;
    return {
        method: 'GET',
        endpoint: `categories`,
        params: Object.assign({ ids: parameters.categoryIds.join(`,`) }, (0, categoryEndpointsParameter_1.parametersForCategoryEndpoint)(Object.assign(Object.assign({}, parameters), { with: Object.assign(Object.assign({}, parameters.with), { children: ((_a = parameters.with) === null || _a === void 0 ? void 0 : _a.absoluteDepth) !== undefined
                    ? Math.max(parameters.with.absoluteDepth - 1, 0)
                    : undefined }) }))),
    };
}
exports.createCategoriesByIdsEndpointRequest = createCategoriesByIdsEndpointRequest;
